import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Popper from '@mui/material/Popper';
import Switch from '@mui/material/Switch';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format, parse } from 'date-fns';
import React from 'react';
import Link from '~/components/Link';
import ENV from '~/constants/ENV';
import NEXT from '~/constants/NEXT';
import { ROUTES } from '~/constants/ROUTES';
import DebugContext from '~/context/DebugContext';
import getIcon from '~/helpers/getIcon';
import { BuildEnv } from '~/types';
import { StyledContainer, StyledDivider, StyledFab, StyledPaper, StyledTypography } from './styles';
const CloseIcon = getIcon('actions.close');
const DebugIcon = getIcon('general.debug');
const Debug = (): React.ReactElement | null => {
  const debugContext = React.useContext(DebugContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isSecurityEnabled, setIsSecurityEnabled] = React.useState(true);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setIsSecurityEnabled(event.target.checked);
    if (NEXT.IS_CLIENT && window.electron) {
      window.electron.send('message', event.target.checked ? 'securityOn' : 'securityOff');
    }
  };
  if (ENV.BUILD_ENV === BuildEnv.Production) {
    return null;
  }
  const isOpen = Boolean(anchorEl);
  const id = isOpen ? 'debug-popper' : undefined;
  const {
    todayDateSimulated
  } = debugContext.state;
  return <>
      <StyledFab color="secondary" onClick={event => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    }} variant="extended" data-sentry-element="StyledFab" data-sentry-source-file="index.tsx">
        {isOpen ? <>
            <CloseIcon />
            &nbsp;Close
          </> : <>
            <DebugIcon />
            &nbsp;Debug
          </>}
      </StyledFab>

      <Popper anchorEl={anchorEl} id={id} key={todayDateSimulated} open={isOpen} placement="top-end" data-sentry-element="Popper" data-sentry-source-file="index.tsx">
        <StyledPaper data-sentry-element="StyledPaper" data-sentry-source-file="index.tsx">
          <StyledTypography variant="subtitle2" data-sentry-element="StyledTypography" data-sentry-source-file="index.tsx">Debug Menu</StyledTypography>
          <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
          <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="index.tsx">
            <DatePicker label="Today's Date (Simulated)" onChange={async (d): Promise<void> => {
            await debugContext.actions.update({
              todayDateSimulated: d ? format(d, 'yyyy-MM-dd') : undefined
            });
          }} value={todayDateSimulated ? parse(todayDateSimulated, 'yyyy-MM-dd', new Date()) : new Date()} data-sentry-element="DatePicker" data-sentry-source-file="index.tsx" />
            <StyledDivider aria-hidden="true" data-sentry-element="StyledDivider" data-sentry-source-file="index.tsx" />
            <Link href={ROUTES.SANDBOX} data-sentry-element="Link" data-sentry-source-file="index.tsx">Navigate to Sandbox</Link>
            <Link href={ROUTES.INDEX} data-sentry-element="Link" data-sentry-source-file="index.tsx">Navigate to Home</Link>
            <FormControlLabel control={<Switch checked={isSecurityEnabled} onChange={handleChange} />} label="Toggle security" slotProps={{
            typography: {
              variant: 'subtitle2'
            }
          }} data-sentry-element="FormControlLabel" data-sentry-source-file="index.tsx" />
          </StyledContainer>
        </StyledPaper>
      </Popper>
    </>;
};
export default Debug;